import Vue from 'vue'
import ProctorBattleDialog from './src/main'

ProctorBattleDialog.install = (options) => {
  if (document.querySelector('.proctorBattleDialog')) {
    let nodes = document.querySelectorAll('.proctorBattleDialog')
    let isHave = false
    nodes.forEach(element => {
      console.log(options.data.title + options.data.text + options.data.yesTxt, element.innerText.replaceAll('\n', ''))
      if (options.data.title + options.data.text + options.data.yesTxt === element.innerText.replaceAll('\n', '')) {
        isHave = true
      }
    })
    if (isHave) return
  }
  const AlterBox = Vue.extend(ProctorBattleDialog)
  let instance = new AlterBox({
    ...options
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.show = true
  })
}

export default ProctorBattleDialog



// WEBPACK FOOTER //
// ./src/plugin/proctorBattleDialog/index.js